<script>
  import moment from "moment";
  import { stringify } from "query-string";
  import { navigate } from "svelte-routing";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import ResourceList from "../components/ResourceList.svelte";
  import { ResourceSelect, ResourceOption } from "../components";
  import Checkbox from "@smui/checkbox";
  import FormField from "@smui/form-field";
  import { exclude } from "@smui/common/exclude.js";

  export let title;
  export let location;
  export let basePath = "/invoices";
  export let vendorId = null;

  let records;
  let list;
  let filter = {};
  let forVendor = vendorId !== null;

  $: props = exclude($$props, ["vendorId"]);

  title = "Invoices";

  function changeFilter(event) {
    if (!event.target.name) {
      console.log("Filter name not set");
    } else {
      console.log("Change filter: ", event.target.name, event);
      if (event.target.value) {
        filter[event.target.name] = event.target.value;
      } else {
        delete filter[event.target.name];
      }
      list.refresh();
    }
  }

  function create() {
    let query;
    if (Object.keys(filter).length > 0) {
      query = "?" + stringify(filter);
    } else {
      query = "";
    }
    console.log("query: ", query);
    navigate(`${basePath}/create${query}`);
  }

  function edit(id) {
    console.log(`Edit ${basePath}/${id}`);
    navigate(`${basePath}/${id}`);
  }

  function perHead(row) {
    if (row.catered_value && row.meal_prep) {
      return row.catered_value / row.meal_prep;
    } else {
      return "";
    }
  }
</script>

<style>

</style>

{(console.log('InvoiceList.filter: ', filter), '')}
<ResourceList
  resource="invoices"
  bind:this={list}
  {location}
  bind:records
  {filter}
  {create}
  {...props}>
  <div slot="filters" class="flex wrap">
    {#if !forVendor}
      <ResourceSelect
        input$name="vendor_id"
        on:change={changeFilter}
        bind:value={vendorId}
        resource="vendors"
        filter={{ has_invoice: true }}
        nameField="vendor_name"
        label="Vendor" />
    {/if}
  </div>
  <Head>
    <Row>
      <Cell>Invoice ref</Cell>
      <Cell>Date</Cell>
      {#if !forVendor}
        <Cell>Vendor</Cell>
      {/if}
      <Cell>Amount ex VAT</Cell>
      <Cell>Amount</Cell>
    </Row>
  </Head>
  <Body>
    {#if records}
      {#each records as row}
        <Row on:click={() => edit(row.id)} class="pointer mdc-data-table__row">
          <Cell>{row.invoice_ref || ''}</Cell>
          <Cell>{moment(row.invoice_date).format('Do MMM')}</Cell>
          {#if !forVendor}
            <Cell>{row.vendor_name || '-'}</Cell>
          {/if}
          <Cell>{row.fd_fee_exc_vat}</Cell>
          <Cell>{row.fd_fee_total}</Cell>
        </Row>
      {/each}
    {/if}
  </Body>
</ResourceList>
